import formatPrice from "@/core/helpers/formatPrice";
import { BankCardIcon, CashIcon } from "@/shared/icons";

type Props = {
  bank: number;
  balance: number;
};

export default function PlayerMenuMoney({ bank, balance }: Props) {
  return (
    <div className="grid grid-cols-2 gap-2 mt-3.5 px-8">
      <div className="flex flex-col items-start justify-center bg-dark-800 rounded-[0.5rem] h-[4rem] px-4">
        <div className="w-full flex items-center justify-between">
          <div className="text-14 font-bold">{formatPrice(bank)} ₽</div>
          <BankCardIcon size={20} />
        </div>
        <div className="text-10 font-bold text-white/50 mt-1">БАНК.КАРТА</div>
      </div>
      <div className="flex flex-col items-start justify-center bg-dark-800 rounded-[0.5rem] h-[4rem] px-4">
        <div className="w-full flex items-center justify-between">
          <div className="text-14 font-bold">{formatPrice(balance)} ₽</div>
          <CashIcon size={20} />
        </div>
        <div className="text-10 font-bold text-white/50 mt-1">НАЛИЧНЫЕ</div>
      </div>
    </div>
  );
}
